// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3m9pn","footer":"Form_footer__3kZys"};